<script lang="ts">
  import type { ChildGroup, EventGroup, Group } from "../interfaces/explore";
  import type { Endpoint as EndpointInterface } from "../interfaces/endpoint";
  import { getCamelCaseBreakString } from "../services/shared";
  import Endpoint from "./endpoint.svelte";
  import Expander from "./expander.svelte";
  import Event from "./event.svelte";
  import InnerHtml from "./inner-html.svelte";

  export let group: Group | null = null;
  export let eventGroup: EventGroup | null = null;
  export let endpointGroup: ChildGroup[] = [];
  export let endpoints: EndpointInterface[] = [];
  export let setEndpointsContainer = (element: Element) => null;

  let endpointsContainer: Element | null = null;
  $: {
    if (endpointsContainer) {
      setEndpointsContainer(endpointsContainer);
    }
  }

  let eventObjectMaps: any[] = [];
  let areEventsExpanded = false;

  const expandEvents = () => {
    areEventsExpanded = !areEventsExpanded;
  };

  const createdObjectMap = (eventName: string, objectMap: any) => {
    eventObjectMaps = [ ...eventObjectMaps, { name: eventName, objectMap: objectMap }];
  };
</script>

<div class="header">
  <h1><InnerHtml htmlType="span" text={getCamelCaseBreakString(group.name)} /></h1>
  <div><InnerHtml htmlType="span" text={group.description} /></div>

  {#if eventGroup?.events}
    <div class="header__infoSection">
      <Expander text={'<h4>events</h4>'} isExpanded={areEventsExpanded} expand={expandEvents} />
      {#if areEventsExpanded}
        <div class="events">
          {#each eventGroup.events as eventObject}
            <Event
              {eventObject}
              {eventObjectMaps}
              {createdObjectMap}
            />
          {/each}
        </div>
      {/if}
    </div>
  {/if}
</div>

<div class="endpoints" bind:this={endpointsContainer}>
  {#each endpointGroup as endpointData}
    <Endpoint
      group={endpointData}
      endpoint={endpoints.find(e => e.request.name === endpointData.name)}
    />
  {/each}
</div>
